import React, { Component } from 'react';
import {Modal,ModalBody,Button, Row, Col} from 'reactstrap';

class KPIDescriptionModal extends Component {
  state = {  }

  render() { 
    const {showModal, kpiList, chartListcategory} = this.props;
    return ( 
      <div>
        <Modal 
          isOpen={showModal}>
          <ModalBody style={{padding:'30px 0px'}}>
            <Row className="row mt10">
              <Col className="offset-md-1 offset-lg-1 learn-more-categories-title">
                 {chartListcategory} Key Performance Indicators
              </Col>
            </Row>
            {kpiList.map((kpi,index) => {
              return <Row className="row mt15" key={kpi.name+index}>
                <Col sm="12" className="offset-md-1 offset-lg-1 learn-more-category">
                   {kpi.name} <span className="fw100">({kpi.code})</span>
                </Col>
                <Col sm="10" className="mt5" className="offset-md-1 offset-lg-1 col-md-offset-right-2 learn-more-category-definition">
                   {kpi.definition}
                </Col>
              </Row>
            })}
              <div className="row mt30">
                <div className="offset-md-1 offset-lg-1 col-md-3 col-lg-3">
                  <Button onClick={this.props.toggle} color="secondary-filled" style={{width:'100%'}}>
                    <span style={{fontSize:'18px',lineHeight:'25px'}}>Done</span>
                  </Button>
                </div>
            </div>
          </ModalBody>
        </Modal>
      </div>
    );
  }
}
 
export default KPIDescriptionModal;